import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import thunk from 'redux-thunk'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import Reducer from './Stores/Reducer'
import axios from 'axios'
import { getChannelId, handleChannelErrorResponse } from './Utilities/channelHeader'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(Reducer, composeEnhancers(applyMiddleware(thunk)))
// Expose store globally so action helper can read transient flags
window.store = store

axios.defaults.baseURL = process.env.REACT_APP_ENITURE_API_URL

// Channel-Specific Configuration Support: many Action files do `import axios
// from 'axios'` directly rather than the Utilities/authToken.js instance -
// since that's the same underlying singleton, registering the interceptor
// here once covers all of them too, not just the shared-instance callers.
axios.interceptors.request.use(config => {
	const channelId = getChannelId()
	if (channelId) {
		config.headers['X-Channel-Id'] = channelId
	}
	return config
})

// Error Handling (SRS section 11): an invalid/deleted channel response recovers by
// resetting to the default channel and reloading - see handleChannelErrorResponse.
axios.interceptors.response.use(
	response => response,
	error => {
		handleChannelErrorResponse(error)
		return Promise.reject(error)
	}
)

ReactDOM.render(
	<Provider store={store}>
		<App />
	</Provider>,
	document.getElementById('root')
)
